import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=d3f8cfae&scoped=true&"
import script from "./BackToTopButton.vue?vue&type=script&lang=js&"
export * from "./BackToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=d3f8cfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8cfae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3f8cfae')) {
      api.createRecord('d3f8cfae', component.options)
    } else {
      api.reload('d3f8cfae', component.options)
    }
    module.hot.accept("./BackToTopButton.vue?vue&type=template&id=d3f8cfae&scoped=true&", function () {
      api.rerender('d3f8cfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/BackToTopButton.vue"
export default component.exports